const serviceDetails = {
  behandlungspflege:{
    title:'Behandlungspflege',
    heroKicker:'Ambulante Behandlung',
    heroTitle:'Ihre Behandlung in den besten Händen',
    lead:
      'Unser examiniertes Team führt ärztlich angeordnete Maßnahmen zuverlässig, sicher und nach modernen pflegerischen Standards durch.',
    introParagraphs:[
      'Unter Behandlungspflege versteht man speziell verordnete Tätigkeiten, die ausschließlich von Pflegefachpersonen durchgeführt werden dürfen. Dazu zählen unter anderem die Versorgung von Wunden, der Wechsel von Verbänden, die Gabe von Medikamenten, Messungen wichtiger Vitalwerte oder die Unterstützung bei ärztlichen Behandlungen.',
      'Jede Verordnung wird von uns individuell geplant und sorgfältig dokumentiert. Außerdem stehen wir in engem Austausch mit behandelnden Ärztinnen und Ärzten, damit das gemeinsame Behandlungsziel immer im Mittelpunkt bleibt.'
    ],
    keyServices:{
      title:'Leistungen der Behandlungspflege',
      items:[
        'Spritzen und Injektionen wie Insulin, Heparin oder Schmerzmedikation',
        'Regelmäßige Kontrolle von Blutdruck, Puls und Atmung',
        'Messung und Einschätzung des Blutzuckers',
        'Tägliche Gabe und Organisation von Medikamenten',
        'Hilfe beim An- und Ausziehen von Kompressionsstrümpfen',
        'Professionelle Versorgung von Wunden sowie sterile Verbände',
        'Unterstützung bei künstlicher Ernährung, Infusionen, Port- oder ZVK-Versorgung',
        'Versorgung von Stomata und Kathetern'
      ],
      note:'Behandlungspflege ist verordnungsfähig und wird genehmigt, wenn sie notwendig ist, um das ärztliche Therapieziel zu sichern.'
    },
    sections:[
      {
        title:'Warum Behandlungspflege so wichtig ist',
        paragraphs:[
          'Diese Form der Pflege erfordert viel medizinisches Wissen, eine ruhige Hand und ein geschultes Auge. Sie kann langfristig nötig sein und wird nicht nur nach einem Krankenhausaufenthalt verordnet.',
          'Unser Team sorgt dafür, dass Behandlungspläne eingehalten werden, Risiken früh erkannt und mögliche Komplikationen vermieden werden. Sorgfalt, Hygiene und ein respektvoller Umgang gehören für uns selbstverständlich dazu.'
        ]
      }
    ]
  },

  grundpflege:{
    title:'Grundpflege',
    heroKicker:'Alltagshilfe mit Herz',
    heroTitle:'Alles für Ihre tägliche Pflege',
    lead:
      'Wir begleiten Sie oder Ihre Angehörigen einfühlsam und zuverlässig im Alltag. Für kurze Zeit oder dauerhaft.',
    introParagraphs:[
      'Zur Grundpflege zählen alle Unterstützungen, die den täglichen Ablauf betreffen: Körperpflege, Ernährung, Mobilität oder die Hilfe beim Toilettengang. Ziel ist es, grundlegende Bedürfnisse sicher abzudecken und die Lebensqualität zu erhalten.',
      'Gemeinsam entwickeln wir einen Plan, der sich an der persönlichen Situation orientiert und Angehörige spürbar entlastet. Ihre Selbstständigkeit und Ihr Wohlbefinden stehen dabei an erster Stelle.'
    ],
    keyServices:{
      title:'Schwerpunkte der Grundpflege',
      items:[
        'Unterstützung bei der Körperpflege wie Waschen, Duschen, Baden, Zahnpflege oder Ankleiden',
        'Hilfe bei der Ausscheidung, der Nutzung der Toilette und der Versorgung bei Inkontinenz',
        'Sichere Mobilisation: Aufstehen, Gehen, Positionswechsel, Lagerungen und Bewegungsübungen',
        'Zubereitung kleiner Mahlzeiten und Begleitung bei der Nahrungs- und Flüssigkeitsaufnahme',
        'Vorbeugende Maßnahmen wie Dekubitusprophylaxe',
        'Anleitung und Unterstützung beim Umgang mit Hilfsmitteln'
      ],
      note:'Jeder Mensch hat das Recht auf eine verlässliche Versorgung seiner grundlegenden Bedürfnisse. Wir unterstützen dabei achtsam und strukturiert.'
    },
    sections:[
      {
        title:'Wie wir arbeiten',
        paragraphs:[
          'Wir orientieren uns an vertrauten Abläufen und ermutigen zur aktiven Mithilfe, soweit es möglich ist. Unsere Dokumentation ist klar nachvollziehbar, und bei Bedarf stimmen wir uns mit Therapeuten, Ärztinnen oder Angehörigen ab.',
          'Durch regelmäßige Beobachtung erkennen wir Veränderungen frühzeitig und können Maßnahmen schnell anpassen.'
        ]
      }
    ]
  },

  rufbereitschaft:{
    title:'24h-Rufbereitschaft',
    heroKicker:'Rund um die Uhr erreichbar',
    heroTitle:'Sicherheit, wenn es darauf ankommt',
    lead:'Unser Team ist jederzeit telefonisch erreichbar und organisiert bei Bedarf kurzfristige Einsätze. Tag und Nacht.',
    introParagraphs:[
      'Gerade in unvorhersehbaren Momenten ist schnelle Hilfe entscheidend. Unsere 24-Stunden-Rufbereitschaft bietet pflegebedürftigen Menschen und Angehörigen genau diese Sicherheit.',
      'Wir koordinieren Kontakte zu Ärztinnen, Apotheken oder Notdiensten, schicken bei Bedarf unser Team los und bleiben so lange erreichbar, bis die Situation geklärt ist.'
    ],
    keyServices:{
      title:'Was Sie erwarten dürfen',
      items:[
        'Ein zentraler Ansprechpartner für dringende Anliegen',
        'Organisation kurzfristiger Hausbesuche oder Einsätze',
        'Absprachen mit Ärztinnen, Apotheken oder Sanitätshäusern',
        'Unterstützende Begleitung für Angehörige in belastenden Situationen'
      ]
    },
    sections:[
      {
        title:'Für wen ist die Rufbereitschaft gedacht?',
        paragraphs:[
          'Ob nach einer Operation, in kritischen Krankheitsphasen oder zur Entlastung von Angehörigen, die Rufbereitschaft ergänzt die geplante Pflege und bietet einen zuverlässigen Rückhalt.',
          'Gemeinsam besprechen wir, in welchen Situationen Sie sich melden möchten und wie wir im Ernstfall helfen.'
        ]
      }
    ]
  },

  beratung:{
    title:'Beratung',
    heroKicker:'Pflege verstehen',
    heroTitle:'Individuelle Beratung und Begleitung',
    lead:'Wir erklären Pflegeleistungen verständlich, unterstützen bei Anträgen und helfen, die richtigen Entscheidungen zu treffen.',
    introParagraphs:[
      'Das Thema Pflege ist oft kompliziert. Wir machen Leistungen, Ansprüche und Möglichkeiten transparent und zeigen, welche Unterstützungen wirklich passen.',
      'Auf Wunsch erstellen wir einen individuellen Plan, der medizinische, pflegerische und soziale Aspekte berücksichtigt.'
    ],
    keyServices:{
      title:'Beratungsschwerpunkte',
      items:[
        'Hilfe bei Anträgen und Genehmigungen',
        'Übersicht zu Leistungen und Finanzierungsmöglichkeiten nach SGB V und XI',
        'Pflegeberatung nach §37 Abs. 3 SGB XI',
        'Pflegekurse und Anleitung für Angehörige',
        'Vernetzung und individuelle Entlastungsangebote vor Ort'
      ]
    },
    sections:[
      {
        title:'Unser Beratungsverständnis',
        paragraphs:[
          'Wir hören zu, nehmen Sorgen ernst und übersetzen Fachbegriffe so, dass Entscheidungen leichter fallen.',
          'Bei Bedarf beziehen wir Ärztinnen, Therapeuten oder weitere Beteiligte ein, damit alle Perspektiven berücksichtigt werden.'
        ]
      }
    ]
  },

  wundmanagement:{
    title:'Wundmanagement',
    heroKicker:'Moderne Versorgung',
    heroTitle:'Spezialisiertes Wundmanagement',
    lead:'Unsere geschulten Fachkräfte versorgen akute und chronische Wunden nach neuesten Erkenntnissen und dokumentieren jeden Schritt transparent.',
    introParagraphs:[
      'Wir verbinden moderne Verbandstoffe mit fachlicher Erfahrung und einer engmaschigen Verlaufsbeobachtung. Ziel ist eine bestmögliche Heilung und die Vermeidung von Komplikationen.',
      'In enger Absprache mit behandelnden Ärztinnen passen wir die Versorgung individuell an Schmerz, Heilungsphase und Alltagssituation an.'
    ],
    keyServices:{
      title:'Leistungen im Wundmanagement',
      items:[
        'Umfassende Wundanamnese, Fotodokumentation und Verlaufskontrolle',
        'Versorgung akuter und chronischer Wunden wie Dekubitus, Ulcera oder diabetisches Fußsyndrom',
        'Professionelles Schmerz- und Exsudatmanagement',
        'Einsatz moderner Verbandmaterialien und Kompressionsmethoden',
        'Beratung zur Hautpflege und Maßnahmen zur Vorbeugung'
      ]
    },
    sections:[
      {
        title:'Warum ein spezialisiertes Team?',
        paragraphs:[
          'Komplexe Wunden brauchen Erfahrung, Zeit und ein strukturiertes Vorgehen. Unsere zertifizierten Fachkräfte arbeiten nach aktuellen Standards und beziehen Betroffene aktiv ein.',
          'Regelmäßige Bewertungen helfen dabei, Therapien anzupassen und Arzttermine optimal vorzubereiten.'
        ]
      }
    ]
  },

  palliativpflege:{
    title:'Palliativpflege',
    heroKicker:'Würdevolle Begleitung',
    heroTitle:'Palliativpflege zu Hause',
    lead:'Wir lindern belastende Symptome, begleiten Gespräche und unterstützen Angehörige. In jeder Phase.',
    introParagraphs:[
      'In der Palliativpflege steht die Lebensqualität im Vordergrund. Wünsche und Bedürfnisse der Betroffenen haben Vorrang, und wir handeln mit Respekt und Einfühlungsvermögen.',
      'Eine gute Symptomkontrolle, transparente Kommunikation und eine vorausschauende Planung geben Sicherheit und Orientierung.'
    ],
    keyServices:{
      title:'Schwerpunkte der Palliativpflege',
      items:[
        'Linderung belastender Symptome wie Schmerzen, Atemnot oder Übelkeit',
        'Begleitung und Pflege in der letzten Lebensphase',
        'Unterstützung bei Vorsorge- und Notfallplanung',
        'Kooperation mit SAPV-Teams, Ärztinnen und Hospizdiensten',
        'Gespräche, Anleitung und Entlastung für Angehörige'
      ]
    },
    sections:[
      {
        title:'Miteinander planen',
        paragraphs:[
          'Wir stimmen Abläufe, Medikamente und Krisenpläne eng mit allen Beteiligten ab. Angehörige werden einbezogen, aber nicht überfordert.',
          'Durch klare Absprachen und feste Routinen entsteht ein Gefühl von Halt und Sicherheit.'
        ]
      }
    ]
  },

  verhinderungspflege:{
    title:'Verhinderungspflege',
    heroKicker:'Entlastung für Angehörige',
    heroTitle:'Verlässliche Vertretung',
    lead:'Wir übernehmen die Pflege, wenn Angehörige einmal nicht können. Ob geplant oder kurzfristig.',
    introParagraphs:[
      'Auszeiten sind wichtig. Wenn Angehörige Urlaub machen, erkranken oder anderweitig verhindert sind, übernehmen wir die Versorgung verantwortungsvoll und orientieren uns an den gewohnten Abläufen.',
      'So bleiben pflegebedürftige Menschen gut betreut, während Angehörige Kraft schöpfen können.'
    ],
    keyServices:{
      title:'Leistungen der Verhinderungspflege',
      items:[
        'Übernahme der Grundpflege orientiert an den gewohnten Routinen',
        'Sichere Medikamentengabe und Behandlungspflege nach ärztlicher Verordnung',
        'Alltagsbegleitung, Gespräche und Aktivierungsangebote',
        'Flexible Einsatzzeiten von Stunden- bis Tagesweise',
        'Unterstützung bei Organisation und Abrechnung mit der Pflegekasse'
      ]
    },
    sections:[
      {
        title:'Nahtlos anschließen',
        paragraphs:[
          'Wir lernen Gewohnheiten und Vorlieben im Vorfeld kennen, damit die Vertretung so reibungslos wie möglich funktioniert.',
          'Durch transparente Absprachen bleiben alle Beteiligten gut informiert.'
        ]
      }
    ]
  },

  pflegeakademie:{
    title:'Pflegeakademie',
    heroKicker:'Qualifizierung mit Struktur',
    heroTitle:'Zum Alltagsbegleiter nach § 45a SGB XI qualifizieren',
    lead:'Praxisnah, begleitet und mit klaren Abläufen bis zum Zertifikat.',
    introParagraphs:[
      'Die Qualifizierung zum Alltagsbegleiter ist sinnstiftend, gefragt und zukunftssicher. Mit unserem Basiskurs nach § 45a SGB XI bereiten wir Sie praxisnah und professionell auf diese verantwortungsvolle Aufgabe vor.',
      'Die Schulung erfolgt strukturiert, begleitet und praxisorientiert mit klaren Abläufen und persönlicher Betreuung. Das bisher bekannte reine Online-Modell steht nicht mehr zur Verfügung.'
    ],
    keyServices:{
      title:'Kursangebot & Vorteile',
      items:[
        'Basiskurs mit 40 Stunden Qualifizierung zum Alltagsbegleiter',
        'Jährlicher Refresher mit 16 Stunden zur Auffrischung',
        'Strukturierter Online-Unterricht mit fachlicher Begleitung',
        'Praxisorientierte Inhalte und erfahrene Dozenten aus der Pflege',
        'Persönliche Ansprechpartner und auf Wunsch mögliche Präsenztermine',
        'Zertifikat nach erfolgreichem Abschluss, orientiert an § 45a SGB XI und der AnFöVO NRW'
      ],
      note:'Nach Zahlungseingang erhalten Sie die Schulungsunterlagen als PDF per E-Mail, bearbeiten diese strukturiert und erhalten anschließend Ihr Zertifikat per Post.'
    },
    contactSection:{
      title:'Kontakt & Anmeldung',
      text:
        'Für weitere Informationen zur Qualifizierung, zum Ablauf oder zur Anmeldung helfen wir Ihnen gerne weiter.',
      phone:'02243 8455323',
      email:'info@curacare-pflegedienst.de',
      formHint:'Alternativ können Sie unser Kontaktformular nutzen.'
    },
    sections:[
      {
        title:'Ablauf und Rahmen',
        paragraphs:[
          'Der Ablauf ist bewusst einfach und transparent aufgebaut: Anmeldung, Bezahlung, Versand der Unterlagen per E-Mail, Bearbeitung mit Feedbackabgabe und anschließend Zusendung des Zertifikats per Post.',
          'Die Preise betragen 445 € für den Basiskurs und 245 € für den Refresherkurs. So erhalten Sie eine fachlich fundierte Weiterbildung in wertschätzender Lernatmosphäre mit echtem Praxisbezug.'
        ]
      }
    ]
  }
};

export default serviceDetails;
